import { createStep } from "../scenario-manager";
import { translator } from "../i18n";
import {
  formatAppointmentLocation,
  formatAppointmentType,
  formatNbPeople,
  formatPractitioner,
  formatProfession,
  formatProfessionalType
} from "../formatter";
import {
  getAppointmentLocation,
  getAppointmentType,
  getAppointmentTypeSequence,
  getNbPeople,
  getPractitioner,
  getProfession,
  getProfessionalType
} from "./scnr2-fetcher";
import Chooser from "../../components/Chooser";
import WISelect from "../../components/WISelect";
import List from "../../components/List";
import { store } from "../../store";

const buildStep1 = stepLabel => {
  const step = createStep({ label: stepLabel }, true);

  const professionalType = createStep({
    code: "professionalType",
    label: translator()._("W_STEP1_CATEGORIE_PROFESSIONEL_DE_SANTE"),
    icon: "images/icone-professionnel.png",
    showLinkPriorityCode: true,
    component: {
      type: Chooser,
      label: translator()._("W_STEP1_CATEGORIE_PROFESSIONEL_DE_SANTE")
    },
    data: {
      fetchSource: getProfessionalType,
      formatSource: formatProfessionalType,
      keyValue: "professionalType"
    },
    returned: {
      key: "professionalType"
    },
    selfRemove: {
      group: "priorityCode"
    }
  });
  step.children.push(professionalType);

  const profession = createStep({
    code: "profession",
    label: translator()._("W_STEP1_PROFESSION"),
    component: {
      type: List,
      label: translator()._("W_STEP1_PROFESSION")
    },
    data: {
      fetchSource: getProfession,
      formatSource: formatProfession,
      keyValue: "profession"
    },
    returned: {
      key: "profession"
    },
    selfRemove: {
      group: "priorityCode"
    }
  });
  if (!store.getState().configuration.bPassProf) {
    step.children.push(profession);
  }

  const appointmentType = createStep({
    code: "appointmentType",
    label: translator()._("W_STEP1_TITRE_MENU_MOTIF_RDV"),
    icon: "images/icone-motif.png",
    showLinkPriorityCode: true,
    component: {
      type: List,
      label: translator()._("W_STEP1_TITRE_MENU_MOTIF_RDV")
    },
    data: {
      fetchSource: getAppointmentType,
      formatSource: formatAppointmentType,
      keyValue: "appointmentType"
    },
    returned: {
      key: "appointmentType"
    }
  });
  step.children.push(appointmentType);

  const appointmentTypeSequence = createStep({
    label: "",
    component: {
      type: WISelect
    },
    data: {
      fetchSource: getAppointmentTypeSequence
    }
  });
  step.children.push(appointmentTypeSequence);

  const appointmentLocation = createStep({
    label: translator()._("W_STEP2_TITRE_LIST_LIEU_RDV"),
    needContinue: true,
    component: {
      type: List,
      label: translator()._("W_STEP2_TITRE_LIST_LIEU_RDV")
    },
    data: {
      fetchSource: getAppointmentLocation,
      formatSource: formatAppointmentLocation,
      keyValue: "appointmentLocation"
    },
    returned: {
      key: "appointmentLocation"
    }
  });
  step.children.push(appointmentLocation);

  const practitioner = createStep({
    label: translator()._("W_STEP2_TITRE_MENU_QUEL_PRATICIEN"),
    icon: "images/icon-praticien.png",
    component: {
      type: List,
      label: translator()._("W_STEP2_TITRE_MENU_QUEL_PRATICIEN")
    },
    data: {
      fetchSource: getPractitioner,
      formatSource: formatPractitioner,
      keyValue: "practitioner"
    },
    returned: {
      key: "practitioner"
    }
  });
  step.children.push(practitioner);

  const nbPeople = createStep({
    code: "nbPeopleCode",
    label: translator()._("W_STEP2_TITRE_MENU_COMBIEN_DE_PERSONNE"),
    component: {
      type: List,
      label: translator()._("W_STEP2_MENU_LIST_NOMBRE_DE_PERSONNE")
    },
    data: {
      fetchSource: getNbPeople,
      formatSource: formatNbPeople,
      keyValue: "nbPeople"
    },
    returned: {
      key: "nbPeople"
    }
  });
  step.children.push(nbPeople);

  return step;
};

export const buildSteps = stepLabels => {
  return [buildStep1(stepLabels[0])];
};

export const getActiveStep = () => ({ step: 0, subStep: 0 });
